import { useCallback, useEffect, useState } from "react";

export type Appearance = "light" | "dark" | "system";

// const prefersDark = () => {
//   if (typeof window === "undefined") {
//     return false
//   }
//   return window.matchMedia("(prefers-color-scheme: dark)").matches
// }

// const applyTheme = (appearance: Appearance) => {
const applyTheme = () => {
  // FORCE LIGHT MODE: Always apply light theme regardless of user preference
  const isDark = false;

  document.documentElement.classList.toggle("dark", isDark);
};

const mediaQuery = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.matchMedia("(prefers-color-scheme: dark)");
};

const handleSystemThemeChange = () => {
  const currentAppearance = localStorage.getItem("appearance") as Appearance;
  // @ts-expect-error force light mode
  applyTheme(currentAppearance ?? "system");
};

export function initializeTheme() {
  const savedAppearance =
    (localStorage.getItem("appearance") as Appearance) || "system";

  // @ts-expect-error force light mode
  applyTheme(savedAppearance);

  mediaQuery()?.addEventListener("change", handleSystemThemeChange);
}

export function useAppearance() {
  const [appearance, setAppearance] = useState<Appearance>("system");

  const updateAppearance = useCallback((mode: Appearance) => {
    setAppearance(mode);
    if (mode === "system") {
      localStorage.removeItem("appearance");
    } else {
      localStorage.setItem("appearance", mode);
    }
    // @ts-expect-error force light mode
    applyTheme(mode);
  }, []);

  useEffect(() => {
    const savedAppearance = localStorage.getItem(
      "appearance",
    ) as Appearance | null;
    updateAppearance(savedAppearance ?? "system");

    return () =>
      mediaQuery()?.removeEventListener("change", handleSystemThemeChange);
  }, [updateAppearance]);

  return { appearance, updateAppearance } as const;
}
